/* eslint-disable */
export default {
  region: 'Regione',
  calling: 'Chiamata',
  logout: 'Disconnetti',
  version: 'Versione',
  settings: 'Impostazioni',
  selectToDialSMS: 'Seleziona per comporre/inviare un SMS',
  selectToDial: 'Seleziona per comporre',
  selectToSMS: 'Seleziona per inviare un SMS',
  clickToDial: 'Fai clic per comporre',
  autoCreateLog: 'Crea automaticamente registro chiamate',
  autoCreateSMSLog: 'Crea automaticamente registro SMS',
  autoLogCalls: 'Registra automaticamente le chiamate',
  autoLogNotes: 'Registra automaticamente le note',
  autoLogSMS: 'Registra automaticamente gli SMS',
  clickToSMS: 'Fai clic per inviare un SMS',
  logSMSContent: 'Registra contenuto SMS',
  clickToDialSMS: 'Fai clic per comporre/inviare un SMS',
  logExtensionCall: 'Registra chiamate interno',
  audio: 'Audio',
  language: 'Lingua',
  feedback: 'Feedback',
  userGuide: 'Novità',
  quickAccess: 'Impostazione accesso rapido',
  report: 'Rapporto analisi',
  shareIdea: 'Condividi idea',
  openEntityFrom: 'Comportamento oggetto Salesforce',
  ctiPanelSize: 'Dimensioni pannello CTI',
  openInNewTab: 'Apri in una nuova scheda',
  openInCurrentTab: 'Apri nella scheda corrente',
  reportIssue: 'Segnala problema',
  contactSupport: "Contatta l'assistenza",
  selectToDialHint:
    "Per un'esperienza migliore, seleziona il numero di telefono da chiamare con RingCentral nella pagina dei numeri di telefono di grandi quantità.",
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
